import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e1ad9f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "app-tooltip__default-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "app-tooltip",
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showTooltip = true)),
    onTouchstart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTooltip = true)),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTooltip = false)),
    onTouchend: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showTooltip = false))
  }, [
    (!_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "?"))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showTooltip)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["app-tooltip__content", `is-${_ctx.placement}`])
            }, [
              _renderSlot(_ctx.$slots, "content", {}, undefined, true)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 32))
}